import { render, staticRenderFns } from "./ChangeColumnDialog.vue?vue&type=template&id=54aadec5"
import script from "./ChangeColumnDialog.vue?vue&type=script&lang=js"
export * from "./ChangeColumnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports